"use strict";
exports.__esModule = true;
exports.makeAddress = function (address, balance, keyIndex, security) { return ({
    address: address,
    keyIndex: keyIndex,
    security: security,
    balance: balance
}); };
/* List of IRI Commands */
var IRICommand;
(function (IRICommand) {
    IRICommand["GET_NODE_INFO"] = "getNodeInfo";
    IRICommand["GET_NEIGHBORS"] = "getNeighbors";
    IRICommand["ADD_NEIGHBORS"] = "addNeighbors";
    IRICommand["REMOVE_NEIGHBORS"] = "removeNeighbors";
    IRICommand["GET_TIPS"] = "getTips";
    IRICommand["FIND_TRANSACTIONS"] = "findTransactions";
    IRICommand["GET_TRYTES"] = "getTrytes";
    IRICommand["GET_INCLUSION_STATES"] = "getInclusionStates";
    IRICommand["GET_BALANCES"] = "getBalances";
    IRICommand["GET_TRANSACTIONS_TO_APPROVE"] = "getTransactionsToApprove";
    IRICommand["ATTACH_TO_TANGLE"] = "attachToTangle";
    IRICommand["INTERRUPT_ATTACHING_TO_TANGLE"] = "interruptAttachingToTangle";
    IRICommand["BROADCAST_TRANSACTIONS"] = "broadcastTransactions";
    IRICommand["STORE_TRANSACTIONS"] = "storeTransactions";
    IRICommand["CHECK_CONSISTENCY"] = "checkConsistency";
    IRICommand["WERE_ADDRESSES_SPENT_FROM"] = "wereAddressesSpentFrom";
})(IRICommand = exports.IRICommand || (exports.IRICommand = {}));
/* Util methods */
exports.asArray = function (x) { return (Array.isArray(x) ? x : [x]); };
exports.getOptionsWithDefaults = function (defaults) { return function (options) {
    return Object.assign({}, defaults, options);
}; }; // tslint:disable-line prefer-object-spread
var PersistenceBatchTypes;
(function (PersistenceBatchTypes) {
    PersistenceBatchTypes["put"] = "put";
    PersistenceBatchTypes["del"] = "del";
})(PersistenceBatchTypes = exports.PersistenceBatchTypes || (exports.PersistenceBatchTypes = {}));
//# sourceMappingURL=types.js.map